import React from "react";
import StoreIconSide from "../Common/svg/storeiconside";
import PhoneIcon from "../Common/svg/phoneicon";
import LocationSvg from "../Common/svg/locationGray";
import { useNavigate } from "react-router-dom";

const StoreInfo = ({ orderData }) => {
  const navigate = useNavigate();

  const order = orderData?.data?.order;
  const store = order?.store;

  if (!order || !store) {
    return (
      <div className="col-md-4">
        <div className="card rounded-4 shadow-sm">
          <div className="card-body">
            <div className="d-flex align-items-center gap-2 mb-3">
              <div className="text-green">
                <StoreIconSide />
              </div>
              <h5 className="text-smoke font16 font700">معلومات المتجر</h5>
            </div>
            <div className="text-center text-muted py-3">
              لا توجد بيانات متجر متاحة
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="col-md-4">
      <div className="card rounded-4 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
              <div className="text-green">
                <StoreIconSide />
              </div>
              <h5 className="text-smoke font16 font700">معلومات المتجر</h5>
            </div>
            <button
              data-tooltip-id="show"
              className="btn btn-primary p-1"
              onClick={() =>
                navigate(`${process.env.PUBLIC_URL}/store/${store.id}`)
              }
            >
              المزيد
            </button>
          </div>
          <ul className="d-flex flex-column gap-2 mt-2">
            <div>
              <h6 className="text-gray">اسم المتجر</h6>
              <h6 className="text-smoke">{store.name || "غير محدد"}</h6>
            </div>
            <li className="d-flex align-items-center gap-1">
              <PhoneIcon />{" "}
              <span className="text-smoke">{store.phone || "غير محدد"}</span>
            </li>
            {store.address && (
              <li className="d-flex align-items-center gap-1">
                <LocationSvg />{" "}
                <span className="text-smoke">{store.address}</span>
              </li>
            )}
            {store.id && (
              <li className="d-flex align-items-center gap-1">
                <span className="text-gray">رقم المتجر:</span>
                <span className="text-smoke">{store.id}</span>
              </li>
            )}
            {store.email && (
              <li className="d-flex align-items-center gap-1">
                <span className="text-gray">البريد الإلكتروني:</span>
                <span className="text-smoke">{store.email}</span>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default StoreInfo;
